// extracted by mini-css-extract-plugin
export default {"tagsLayout":"Tags_tagsLayout__ztkft","tagsOuterContent":"Tags_tagsOuterContent__ZeX6-","tagsContent":"Tags_tagsContent__VFbS1"};